//# sourceMappingURL=my-marked-dates.interface.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/mydatepicker/dist/interfaces/my-marked-dates.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-marked-dates.interface.js
// module chunks = 4